module.exports = __webpack_public_path__ + "media/images/icons/person-0bf81cfc888f0b22099b7c404eae7794.png";